import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAdmin } from "./AdminLayout";
import { useAdminLang, STATUS_LABELS, SOURCE_LABELS } from "./adminLang";

const Dashboard = () => {
  const { user } = useAdmin();
  const { lang, tr } = useAdminLang();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/admin/analytics").then((r) => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <p className="text-white/40 text-sm" data-testid="dashboard-loading">{tr("Chargement…", "Loading…")}</p>;

  const cards = [
    { label: tr("Leads totaux", "Total leads"), value: data.leads_total, testid: "stat-total-leads" },
    { label: tr("Nouveaux leads", "New leads"), value: data.leads_new, testid: "stat-new-leads" },
    { label: tr("Ce mois-ci", "This month"), value: data.leads_month, testid: "stat-month-leads" },
    { label: tr("Candidatures", "Applications"), value: data.counts.applications, testid: "stat-applications" },
    { label: tr("Demandes de couverture", "Coverage requests"), value: data.counts.coverage, testid: "stat-coverage" },
    { label: tr("Demandes de devis", "Quote requests"), value: data.counts.quotes, testid: "stat-quotes" },
    { label: tr("Messages", "Messages"), value: data.counts.messages, testid: "stat-messages" },
    { label: tr("Abonnés newsletter", "Newsletter subscribers"), value: data.counts.newsletter, testid: "stat-newsletter" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-2xl font-black text-white">{tr("Tableau de bord", "Dashboard")}</h1>
      <p className="mt-1 text-sm text-white/45">{tr("Bonjour", "Hello")} {user.full_name || user.email} — {tr("rôle", "role")} : <span className="text-[#FF9900] font-bold">{user.role}</span></p>

      <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.testid} data-testid={c.testid} className="bg-[#101214] border border-white/10 rounded-2xl p-5">
            <p className="text-3xl font-black text-[#FF6600]">{c.value}</p>
            <p className="mt-1 text-xs text-white/50">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-[#101214] border border-white/10 rounded-2xl p-6" data-testid="stat-by-source">
          <h2 className="font-bold text-white text-sm">{tr("Leads par source", "Leads by source")}</h2>
          <div className="mt-4 space-y-3">
            {Object.entries(data.by_source).map(([k, v]) => (
              <div key={k}>
                <div className="flex justify-between text-xs text-white/60 mb-1"><span>{SOURCE_LABELS[lang][k] || k}</span><span>{v}</span></div>
                <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
                  <div className="h-full bg-[#FF6600] rounded-full" style={{ width: `${Math.min(100, (v / Math.max(1, data.leads_total)) * 100)}%` }} />
                </div>
              </div>
            ))}
            {Object.keys(data.by_source).length === 0 && <p className="text-xs text-white/35">{tr("Aucune donnée.", "No data.")}</p>}
          </div>
        </div>
        <div className="bg-[#101214] border border-white/10 rounded-2xl p-6" data-testid="stat-by-status">
          <h2 className="font-bold text-white text-sm">{tr("Pipeline", "Pipeline")}</h2>
          <div className="mt-4 space-y-3">
            {Object.entries(data.by_status).map(([k, v]) => (
              <div key={k}>
                <div className="flex justify-between text-xs text-white/60 mb-1"><span>{STATUS_LABELS[lang][k] || k}</span><span>{v}</span></div>
                <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
                  <div className="h-full bg-[#FF9900] rounded-full" style={{ width: `${Math.min(100, (v / Math.max(1, data.leads_total)) * 100)}%` }} />
                </div>
              </div>
            ))}
            {Object.keys(data.by_status).length === 0 && <p className="text-xs text-white/35">{tr("Aucune donnée.", "No data.")}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
